import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageRootWrapper } from '@/components/shared/PageRootWrapper';
import { ServiceListContainer } from '@/components/pages/Home/ServiceList';

export const HomePage: React.FC = () => {
  const { t } = useTranslation();
  const title = t('pages.home.title');

  return (
    <PageRootWrapper title={title} containerType="wide">
      <ServiceListContainer />
    </PageRootWrapper>
  );
};
